import React from "react";
import "./Invitation_Bonus.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Invite_Top_Banner from "./Invite_Top_Banner/Invite_Top_Banner";
import Invite_Action_Cards from "./Invite_Action_Cards/Invite_Action_Cards";
import Bonus_Card from "./Bonus_Card/Bonus_Card";
import No_data from "../Common/No_data/No_data";

function Invitation_Bonus() {
  return (
    <section className="Invitation_Bonus">
      <Common_white_header headingText={"Invitation Bonus"} />

      <Invite_Top_Banner />
      <Invite_Action_Cards />

      <div className="container">
        <Bonus_Card
          bonusNo="01"
          amount="55.00"
          invites="1/1"
          deposits="1/1"
        />

        <Bonus_Card
          bonusNo="02"
          amount="155.00"
          invites="3/3"
          deposits="3/3"
        />
      </div>

       <No_data/>
    </section>
  );
}

export default Invitation_Bonus;